<template>
  <!--  IT课程学习页面 提问小模块  wjl 2022.8.22 -->
    <div class="putQuestions">

      <div v-if="questions && questions.length" class="showQuestion">
        <div class="putQuestionsItem" v-for="(item, index) in questions" :key="index + '_' + questions.length">
          <div class="itemTool">
            <span style="font-size: 10px;color: #B6B6BB;">{{ item.createTime }}</span>
            <span v-if="userType === '2'" class="rightTool">
              <span @click="editAsk(item)" class="toolStyle el-icon-edit-outline"></span>
              <span @click="deleteAsk(item)" class="toolStyle el-icon-delete"></span>
              <span style=" display: flex;align-items: center;font-size: 13px;">
                <span>{{ item.isAnswer? '已解答':'未解答' }}</span>
                <el-switch
                  v-model="item.isAnswer"
                  active-color="#1890FF"
                  :active-value="1"
                  @change="updateAsk(item.content, item)"
                  :inactive-value="0">
                </el-switch>
              </span>
            </span>
          </div>
          <div class="itemToolLabel">
						<div class="name_left">
							<el-breadcrumb separator="/">
								<el-breadcrumb-item :title="item.catalogName">{{ item.catalogName }}</el-breadcrumb-item>
								<el-breadcrumb-item :title="item.resourceName">{{ item.resourceName }}</el-breadcrumb-item>
							</el-breadcrumb>
							<span v-if="item.pageLocation" class="askLabel">{{ item.pageLocation }}</span>
						</div>
            <span class="writeDown" v-if="(userType === '2' || userType === '3') && item.isAnswer === 1" @click="editStatus(item, 'addRecord')">记一笔</span>
          </div>
          <!-- <editor
            v-if="item.edit"
            :showBorder="false"
            v-model="item.content"
            height="100px"
            :toolMenus="editorMenus"
            @onblur="editorBlur( arguments[0], item ,'content' )"
            :onlyKey="item.id + 'editQuestion'">
          </editor> -->
          <p class="editorShowArea" :title="item.content" v-html="item.content"></p>
          <div v-if="userType === '2' || userType === '3'">
						<el-input
							v-if="item.addRecord"
							v-model="askRecord"
							height="100px"
							@blur="editorBlur(askRecord, item , 'askRecord' )"
						  type="textarea"
						  placeholder="请输入内容(失焦时自动保存)"
						  maxlength="150"
							resize="none"
						>
						</el-input>
						
						
            <div
              v-for="(record, rindex) in item.askRecordList"
              :key="rindex + 'record'"
              class="recordStyle"
            >

              <!-- <editor
                v-if="record.editorRecord"
                :showBorder="false"
                v-model="record.content"
                height="100px"
                :toolMenus="editorMenus"
                @onblur="editorBlur(arguments[0], record , 'editorRecord' )"
                :onlyKey="record.id + rindex + '_editorRecord'">
              </editor> -->
							<el-input
								v-if="record.editorRecord"
								v-model="record.content"
								height="100px"
								@blur="editorBlur(record.content, item , 'editorRecord', rindex)"
							  type="textarea"
							  placeholder="请输入内容(失焦时自动保存)"
							  maxlength="150"
								resize="none"
							>
							</el-input>
              <el-tooltip v-else placement="top">
                <div slot="content" style="cursor: pointer" @click="editStatus(record, 'editorRecord')">编辑</div>
                <div class="editorShowArea" v-html="record.content"></div>
              </el-tooltip>

              <span class="el-icon-close" @click="deleteAskRecord(record)"></span>
            </div>

          </div>


        </div>
      </div>
      <div v-else-if="userType === '2'" class="isEmpty">
        <el-empty :image-size="100" description=" ">
          <p>可以去发起提问哦</p>
          <p>学习就是不断发现问题再解决的过程</p>
        </el-empty>
      </div>
      <div class="setQuestion" v-if="userType == 2 || userType == 3">
        <!-- <editor v-model="questionContent" height="100px" :toolMenus="editorMenus" :onlyKey="questionId + 'setQuestion'"></editor> -->
				<el-input
				  type="textarea"
				  placeholder="请输入问题"
				  v-model="questionContent"
				  maxlength="150"
					resize="none"
				>
				</el-input>
        <div class="bottombtn">
          <el-button size="mini" type="primary" @click="addQuestion()" >提交</el-button>
        </div>
      </div>
    </div>
</template>

<script>
  /**
   *   提问小模块
   *    wjl 2022.8.22
   */
    import editor from "../../../components/wjlEditor/index.vue";
    import * as api from "@/api/putQuestions";

    export default {
      name: "putQuestions",
      components:{ editor },
      props:{
        query: {
          type: Object,
          default: ()=>{},
        },
        resource: {
          type: Object,
          default: ()=>{},
        }
      },
      data(){
          return {
            userType: sessionStorage.getItem('userType'),
            questions: [],
            questionContent:'',
            questionId:'',
            editorMenus:[ // 富文本菜单栏
              "bold", // 加粗
              "underline", // 下划线
              "italic", // 斜体
              "strikeThrough", // 横穿线
              "foreColor", // 文字颜色
              "backColor", // 背景色
              "image", // 图片
            ],
            askRecord: '',
						askId: '',
						askObj: null
          }
      },
      created(){
        this.init();

      },
      methods:{
        init(){
          this.vLoading = true;
          let params = {
            "catalogId": this.query.catalogId,      //章节id
            "classId": this.query.classId,		      //班级id
            "courseId": this.query.courseId,        //课程id
            "resourceId": this.query.id,            //试题id
            "pageNum": 1,
            "pageSize": 2000,
          }
          if (this.userType === '2'){
            // 学生时
            this.getStudentAsk(params)

          }else{
            // 教师 或 管理员时
            this.getTeacherAsk(params)
          }
        },
        getStudentAsk(params){
          api.studentFindAsk(params).then( res =>{
            if (res.code === '0'){

              this.questions = res.data.list

            }
          }).finally(()=> this.vLoading = true)
        },
        getTeacherAsk(params){
          api.teacherFindAsk(params).then( res =>{
            if (res.code === '0'){

              this.questions = res.data.list

            }
          })
        },

        addQuestion(){
					if(!this.questionContent){
						this.$messageWarning('请输入问题');
						return
					}
					if(this.askId){ //编辑提问
						this.updateAsk(this.questionContent,this.askObj)
					}else{ //新增提问
						let params = {
						  "catalogId": this.query.catalogId,      //章节id
						  "classId": this.query.classId,		      //班级id
						  "courseId": this.query.courseId,        //课程id
						  "resourceId": this.query.id,            //试题id
						  "resourceType":9,                       //固定传9
						  "resourceName": this.resource.name,
						  "pageLocation": this.resource.name,
						  "content": this.questionContent,        //提问的问题
						}
						api.addAsk(params).then( res =>{
						  if (res.code === '0'){
						    this.init();
						    this.$message({
						      type: 'success',
						      message: '添加成功!'
						    });
								this.questionContent = ''
						  }
						})
					}

        },
        // 修改状态触发
        editStatus(item, key){
          this.$set(item, key, true);
        },
        // 文本失焦触发修改接口
        editorBlur( val, item, type, index){
					if(val){
						if(type === 'askRecord'){  // 添加解答
							console.log(item,index);
						  let params = {
						    "content": val,
						    "askId": item.id,
						  }
						  this.saveAskRecord(params)
						} else if (type === 'editorRecord'){ // 编辑解答内容
							console.log(item,index);
						  let params = {
						    "content": val,
						    "askId": item.id,
						    "id": item.askRecordList[index].id,
						  }
						  this.saveAskRecord(params)
						}
					}else{
						this.$messageWarning('请输入内容');
					}
          
        },
				// 编辑提问
				editAsk(item){
					console.log(item)
					this.askId = item.id
					this.askObj = item
					this.questionContent = item.content
				},
        // 添加提问简要，或修改提问简要
        saveAskRecord(params){
          api.saveAskRecord(params).then(res =>{
            if (res.code === '0'){
              this.init();
              this.$message({
                type: 'success',
                message: '修改成功!'
              });
							this.askRecord = ''
            }else{
              this.$message({
                type: 'info',
                message: res.msg
              });
            }
          }).catch(() => { });
        },

        // 删除问题
        deleteAsk(item){
          this.$confirm('删除该提问内容请继续?', '删除问题', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(() => {
            api.deleteAsk(item.id).then( res =>{
              if (res.code === '0'){
                this.init();
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
              }else{
                this.$message({
                  type: 'info',
                  message: res.msg
                });
              }
            })

          }).catch(() => { });
        },
        // 编辑问题
        updateAsk(val, item){
          let params = {
            "content": val,
            "isAnswer": item.isAnswer,   //是否已解答：0 否 1 是
            "id": item.id
          }
          api.updateAsk(params).then(res =>{
            if (res.code === '0'){
              this.init();
              this.$message({
                type: 'success',
                message: '修改成功!'
              });
							this.questionContent = '';
							this.askId = ''
							this.askObj = null;
            }else{
              this.$message({
                type: 'info',
                message: res.msg
              });
            }
          }).catch(() => { });
        },
        // 删除简要
        deleteAskRecord(record){
          this.$confirm('删除该内容请继续?', '删除简要', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(() => {
            api.deleteAskRecord(record.id).then( res =>{
              if (res.code === '0'){
                this.init();
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
              }else{
                this.$message({
                  type: 'info',
                  message: res.msg
                });
              }
            })

          }).catch(() => { });

        },
      }

    }
</script>

<style scoped lang="scss">
.putQuestions{
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;

  .isEmpty{
    flex: 1;
    font-size: 12px;
    text-align: center;
    color: #42414D;
    display: flex;
    align-items: center;
    justify-content: center;
    p{
      margin-bottom: 10px;
    }
  }

  .showQuestion{
    flex: 1;
    overflow-y: auto;
    padding: 10px;
    .putQuestionsItem{
      border-bottom: 1px solid #EDEDF0;
      padding: 16px 0;
      .itemTool{
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .rightTool{
          display: flex;
          align-items: center;
          color: #42414D;
          font-size: 14px;
          .toolStyle{
            margin-right: 14px;
            cursor: pointer;
            &:hover{
              color: #0e9aff;
            }
          }
        }
      }
      .itemToolLabel{
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 12px;
        margin-bottom: 10px;
        .askLabel{
          background: #e3eef7;
          padding: 3px 6px;
          border-radius: 3px;
          color: #136EC2;
					margin-left: 5px;
        }
				.name_left {
					display: flex;
					align-items: center;
					justify-content: flex-start;
				}
				/deep/ .el-breadcrumb {
					.el-breadcrumb__item {
						span {
							font-size: 14px;
							font-weight: 600;
							color: #42414D;
						}
						.el-breadcrumb__separator {
							margin: 0 5px;
						}
					}
				}
        .writeDown{
          color: #1890FF;
          cursor: pointer;
        }
      }
			.editorShowArea {
				font-size: 12px;
				color: #42414D;
				display: -webkit-box;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 3;
				overflow: hidden;
				max-height: 60px;
				line-height: 22px;
			}
    }
  }

  .setQuestion{
    /*border-top: solid 2px  #cccccc;*/
		height: 160px;
    box-shadow: 0px -3px 4px -1px rgba(189,189,189,0.21);
    padding: 10px;
		/deep/ .el-textarea {
			.el-textarea__inner {
				border: 0;
				min-height: 120px !important;
			}
		}
		.bottombtn {
			text-align: right;
			margin-top: 12px;
		}
  }

  .recordStyle{
    background: #f4f8f9;
    font-size: 12px;
    color: #666666;
    line-height: 21px;
    padding: 8px 14px;
    margin-top: 10px;
    margin-left: 20px;
    border-left: solid 2px #8790A4;
    position: relative;
    .el-icon-close{
      font-size: 12px;
      border: 1px #666666 dashed;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/IT/components/putQuestions.vue